import gql from 'graphql-tag';

const DELETE_SHARING_REDCORD = gql`
  mutation deleteSharingRecord($recordId: Int!) {
    deleteSharingRecord(where: { id: $recordId })
  }
`;

export default DELETE_SHARING_REDCORD;
